exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.map-parent {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 50px);\n    width:100%;\n    padding:16px;\n}\n.popup br {\n    margin:5px 0;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bc69bb5","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/view/Timesheet_Map.vue
// module id = 584
// module chunks = 0